export const EMPTY_LAYER_DATA = {
  type: 'FeatureCollection',
  features: [],
};
